var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AnimatedNumber from '@/components/ui/AnimatedNumber/AnimatedNumber';
import { classNameMerge } from '@/lib/utils';
import currencyFormatter from '@/utils/currencyFormatter';
import React, { useEffect, useState } from 'react';
import { progressBarContainerVariants, progressBarTitleLabelVariants, progressBarTitleVariants, progressBarVariants } from './progressBarStyles';
var ProgressBar = React.forwardRef(function (_a, ref) {
    var className = _a.className, currency = _a.currency, fixedPercentage = _a.fixedPercentage, raised = _a.raised, size = _a.size, target = _a.target, props = __rest(_a, ["className", "currency", "fixedPercentage", "raised", "size", "target"]);
    var _b = useState(0), progress = _b[0], setProgress = _b[1];
    var percentageComplete = fixedPercentage || (raised > target ? 100 : (raised / target) * 100);
    useEffect(function () {
        var frame = requestAnimationFrame(function () {
            setProgress(percentageComplete);
        });
        return function () { return cancelAnimationFrame(frame); };
    }, [percentageComplete]);
    return (_jsxs("div", __assign({ className: classNameMerge("".concat(className, " ").concat(progressBarContainerVariants({ size: size }))), "data-testid": "progress-bar-container", ref: ref }, props, { children: [_jsx("div", { "aria-label": "Campaign has raised ".concat(percentageComplete, " of target"), "aria-valuemax": 100, "aria-valuemin": 0, "aria-valuenow": percentageComplete, className: classNameMerge(progressBarVariants({ size: size })), "data-testid": "progress-bar", role: "progressbar", children: _jsx("div", { className: "bg-primary h-full rounded-full transition-all duration-1000 ease-out", "data-testid": "progress-bar-fill", style: { width: "".concat(progress, "%") } }) }), _jsx("div", { className: "flex flex-row justify-between items-end", "data-testid": "progress-bar-header", children: _jsxs("h5", { className: classNameMerge(progressBarTitleVariants({ size: size })), "data-testid": "progress-bar-raised", children: [_jsx(AnimatedNumber, { duration: 1000, formatter: function (n) { return (fixedPercentage ? "".concat(n, "%") : currencyFormatter(currency).format(n)); }, target: fixedPercentage || raised }), _jsxs("span", { className: classNameMerge("".concat(progressBarTitleLabelVariants({ size: size }))), "data-testid": "progress-bar-raised-label", children: [' ', "raised"] })] }) })] })));
});
ProgressBar.displayName = 'ProgressBar';
export default ProgressBar;
